import { FeatherIcon } from '../../components/FeatherIcon'
import { useMediaSrc } from '../useMediaSrc'
import type { Preview } from './vaultData'

/** One of the 32px overlapping previews on a category row (design `mPrev`). */
export function PreviewThumb({ preview }: { preview: Preview }) {
  const { ref, src } = useMediaSrc(preview.type === 'audio' ? '' : preview.url)
  return (
    <span ref={ref as React.RefObject<HTMLSpanElement>} className="lib-prev">
      {preview.type === 'audio' ? <FeatherIcon name="mic" size={13} /> : src && <img src={src} alt="" loading="lazy" />}
    </span>
  )
}
